import type { VoidFunctionComponent } from 'react';

import useToggle from '../../../hooks/useToggle';
import Button from '../../generic/Button';
import type { LicenseSummary } from '../../../../shared/types/licenses';
import type { License } from '../../../types';

import styles from './LicenseDetail.module.less';

type LicenseDetailProps = {
  license: License & { Summary?: LicenseSummary };
};

const LicenseDetail: VoidFunctionComponent<LicenseDetailProps> = ({ license }) => {
  const [isDetailsOpen, toggleIsDetailsOpen] = useToggle(true);

  return (
    <div className={styles.licenseDetail}>
      {isDetailsOpen ? (
        <div className={styles.licenseDetailContainer}>
          <div className={styles.licenseDetailTitle}>{license.name}</div>
          <div>
            {license.Summary ? license.Summary.summary : license.licenseComments}
          </div>
          {license.Summary && license.Summary.Terms && (
            <div>
              <div className={styles.obligationsHeader}>Obligations</div>
              <ul>
                {license.Summary.Terms.filter((term) => term.role === 'MUST').map((term) => (
                  <li>{term.termId}</li>
                ))}
              </ul>
            </div>
          )}
          <Button onClick={toggleIsDetailsOpen} type="text">
            <div className={styles.buttonText}>Hide details</div>
          </Button>
        </div>
      ) : (
        <Button onClick={toggleIsDetailsOpen} type="text">
          <div className={styles.buttonText}>About this license</div>
        </Button>
      )}
    </div>
  );
};

export default LicenseDetail;
